import { IValidatorFactoryService } from './validator-factory.service';
import { IUniqueNameMetadata } from 'app/extensibility/metadatas/validator/unique-name-metadata';
import { IValidatorFn } from 'app/interfaces/IValidatorFn';
import { ModelService } from 'app/model/services/model.service';
import { Metamodel } from 'app/model/base/model';
import { Named } from 'app/model/base/named';
import { format } from 'app/shared/utils/string.util';
import { Injector } from '@angular/core';

export class UniqueNameValidatorFactoryService implements IValidatorFactoryService<IUniqueNameMetadata> {
    // eslint-disable-next-line
    public readonly type: string = 'uniqueName';

    public createValidatorByMetadata(metadata: IUniqueNameMetadata, injector: Injector): IValidatorFn {
        return this.createValidator(metadata.entity, metadata.errorMessage, injector);
    }
    public createValidator(entity: Named, errMsg: string, injector: Injector): IValidatorFn {
        const errorMessage = errMsg != null ? errMsg : stringResources.Validator_ErrorMessage_Unique;
        const modelService = injector.get<ModelService>(ModelService);

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (value: any) => {
            return modelService.isUniqueName(value, Metamodel.modelOf(entity), entity) ? null : errorMessage;
        };
    }

    // fixed duplicate naming validator: A(n) [entityType] with the same name already exists in the workspace/factory
    public createValidatorNew(entity: Named, entityType: string, injector: Injector): IValidatorFn {
        const errorMessage = format(stringResources.Validator_NameExist, entityType, '',
            __IS_A365__? stringResources.WorkspaceLowerCase : stringResources.FactoryLowerCase);
        const modelService = injector.get<ModelService>(ModelService);

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (value: any) => {
            return modelService.isUniqueName(value, Metamodel.modelOf(entity), entity) ? null : errorMessage;
        };
    }
}
